import React from "react"
import lodash from "lodash"

const SettingsContext = React.createContext({
  settings: {},
  update: lodash.noop
})

export default SettingsContext
